const REGULAR_PAGE_AMOUNT = 6

export const getShowNumber = ({ step, pageLimit, numOfSteps, currentStep }) => {
  const FIRST_STEP = 1
  const PREV_STEP = currentStep - 1
  const NEXT_STEP = currentStep + 1

  const showNumber =
    // because after 6 replace one number by ...
    // so we show one less number 1 2 3 4 5 6 => 1 2 3 4  ... 7 (remove 5 , last page moves from 6 to 7)
    numOfSteps <= REGULAR_PAGE_AMOUNT ||
    // always show first and last
    step === FIRST_STEP ||
    step === numOfSteps ||
    // show if we are at the start
    inTheStartZone(currentStep, step, pageLimit) ||
    // show numbers of and next to currentStep
    step === currentStep ||
    step === PREV_STEP ||
    // but only do + 1 when we are out of the start (eg. currentStep > 4)
    (step === NEXT_STEP && afterTheStartZone(currentStep)) ||
    isAtTheEnd(currentStep, step, numOfSteps)
  return showNumber
}

export const getShowEllipseAtEnd = (numOfSteps, step, currentStep) =>
  numOfSteps > REGULAR_PAGE_AMOUNT &&
  step === numOfSteps - 1 &&
  !isAtTheEnd(currentStep, step, numOfSteps)

export const getShowEllipseAtStart = (numOfSteps, step, currentStep) =>
  numOfSteps > REGULAR_PAGE_AMOUNT &&
  afterTheStartZone(currentStep) &&
  step === 2

export const isAtTheEnd = (currentStep, step, numOfSteps) =>
  step > numOfSteps - 4 && currentStepIsInTheEndZone(currentStep, numOfSteps)

export const currentStepIsInTheEndZone = (currentStep, numOfSteps) =>
  currentStep > numOfSteps - 3

// need 9 when there are two elipsis, either regular case or at the end.
// In other cases there would be two elipsis (because they start once pageLimit is overstepped)
// If numOfSteps < 8, only show a column for every nr + the two arrows
export const getGridColumnsNumber = (currentStep, pageLimit, numOfSteps) =>
  numOfSteps < 8
    ? numOfSteps + 2
    : currentStep < pageLimit ||
      currentStepIsInTheEndZone(currentStep, numOfSteps)
    ? 8
    : 9

export const afterTheStartZone = (currentStep) => currentStep > 4

export const inTheStartZone = (currentStep, step, pageLimit) =>
  step < pageLimit && currentStep < pageLimit
